import Vue from 'vue'
import App from './App.vue'

// 加载主要组件
import store from './store'
import router from './router'

Array.prototype.unique = function() {
  let arr = this,
    result = [],
    i,
    j,
    len = arr.length

  for (i = 0; i < len; i++) {
    for (j = i + 1; j < len; j++) {
      if (arr[i] === arr[j]) {
        j = ++i
      }
    }
    result.push(arr[i])
  }
  return result
}

//登陆拦截
router.beforeEach((to, from, next) => {
  if (/^\/[home|admin]/.test(to.path)) {
    // to.meta.show = true;
    // 判断该路由是否需要登录权限
    if (store.state.user.info) {
      // 通过vuex state获取当前的token是否存在
      next()
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next()
  }
})

// 加载插件
const files = require.context('./plugins', false, /\.js$/)
files.keys().forEach(key => {
  require(`./plugins/${key.replace(/(\.\/|\.js)/g, '')}`)
})
Vue.config.productionTip = false

// import VueSocketio from 'vue-socket.io';

// Vue.use(VueSocketio, socketio('http://localhost:2019/')); //与服务端链接
import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'

Vue.use(
  new VueSocketIO({
    debug: process.env.NODE_ENV !== 'production',
    connection: process.env.NODE_ENV === 'production' ? SocketIO('') : SocketIO('ws://localhost:2019'),
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_'
    }
  })
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
